import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { show: Boolean, id: String }

  connect() {
    if (this.showValue || this.fetchQueryParam()) {
      this.show()
    }
  }

  manualShow({ detail }) {
    if (detail != this.idValue) return

    this.show()
  }

  show() {
    this.element.showModal()
    document.body.style.overflow = "hidden"
    this.contentTarget.classList.remove("opacity-0", "scale-90")
  }

  close() {
    this.contentTarget.classList.add("opacity-0", "scale-90")
    this.removeQueryParam()
  }

  transitionEnd(event) {
    if (this.contentTarget.classList.contains("opacity-0")) {
      this.element.close()
      document.body.style.overflow = ""
    }
  }

  reset() {
    document.body.style.overflow = ""
    this.contentTarget.classList.add("opacity-0", "scale-90")
    this.removeQueryParam()
  }

  fetchQueryParam() {
    return new URLSearchParams(window.location.search).get(this.fetchQueryParamName())
  }

  fetchQueryParamName() {
    return this.idValue.replace(/_modal$/, "")
  }

  removeQueryParam() {
    if (!this.fetchQueryParam()) return

    const url = new URL(window.location.href)
    url.searchParams.delete(this.fetchQueryParamName())
    window.history.replaceState({}, "", url)
  }
}
